<script setup lang="ts">
import useResize from '@/modules/common/composables/use-resize.ts';
import { computed, ref } from 'vue';

const { noTransition } = defineProps<{
  open: boolean;
  noTransition?: boolean;
}>();

const height = ref(0);

const heightStyle = computed(() => `${height.value}px`);

const contentRef = useResize(() => {
  const dimensions = contentRef.value!.getBoundingClientRect();

  if (dimensions.height !== 0) {
    height.value = dimensions.height;
  }
});

const transitionName = computed(() => (noTransition ? '' : 'spoiler'));
</script>

<template>
  <Transition :name="transitionName">
    <div
      v-show="open"
      class="ui-spoiler"
    >
      <div
        ref="contentRef"
        class="content"
      >
        <slot />
      </div>
    </div>
  </Transition>
</template>

<style scoped lang="scss">
.ui-spoiler {
  height: v-bind(heightStyle);
}

.spoiler {
  &-enter-active,
  &-leave-active {
    overflow: hidden;
    transition: height var(--transition);
  }

  &-enter-from,
  &-leave-to {
    height: 0;
  }
}
</style>
